// import api from "./apiService";
// import {API} from "../constants"
// let cachedData = null;
// let lastFetched = null;

// const CACHE_DURATION_MS = 3 * 60 * 1000; // 3 minutes

// const EmployeeService = {
//   fetchEmployees: async (forceRefresh = false) => {
//     const now = Date.now();

//     // If cached and still valid, return it
//     if (cachedData && lastFetched && now - lastFetched < CACHE_DURATION_MS && !forceRefresh) {
//       return cachedData;
//     }

//     // Else, fetch fresh data
//     const response = await api.get(API.EMPLOYEE_GET_LIST);
//     cachedData = response.data.data;
//     lastFetched = now;

//     return cachedData;
//   },
// };

// export default EmployeeService;

import { useDispatch, useSelector } from "react-redux";
import { cacheApiRequest } from "../utils/cacheApiRequest";
import { clearCache, clearAllCacheForBaseKey } from "../store/cacheSlice";

export const useEmployeeService = () => {
  const dispatch = useDispatch();
  const cache = useSelector((state) => state.cache.cache);

  const fetchEmployees = async (params = {}, forceRefresh = false) => {
    const key = "EMPLOYEE_LIST";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchFaceData = async (
    params = { empId: "All" },
    forceRefresh = false
  ) => {
   
    const key = "EMPLOYEE_GET_FACE_DATA";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    const result = await cacheApiRequest(key, dispatch, cache, { params });
     console.log('result',result);
    return result;
  };

  const fetchDetailedLog = async (params, forceRefresh = false) => {
    const key = "EMPLOYEE_GET_DETAILED_SESSION_LOG";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchAttendanceLogs = async (params, forceRefresh = false) => {
    const key = "EMPLOYEE_GET_ATTENDANCE_LOGS";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const fetchDetailedAttendanceLogs = async (params, forceRefresh = false) => {
    const key = "EMPLOYEE_GET_ATTENDANCE_LOGS_DETAILED";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };


   const fetchEmployeeValidationRequirement = async (
    params = { EmployeeId: "All" },
    forceRefresh = false
  ) => {
    const key = "EMPLOYEE_GET_VALIDATION_REQUIREMENTS";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };


   const updateEmployeeValidationRequirement = async (data = {}) => {
    const key = "EMPLOYEE_POST_VALIDATION_REQUIREMENTS";
    const result = await cacheApiRequest(key, dispatch, cache, { data });
   // await fetchAssignedLocations({ EmployeeId: "All" }, true); // this will refresh the assigned locations after assignment
    return result;
  };


  const fetchAssignedLocations = async (
    params = { EmployeeId: "All" },
    forceRefresh = false
  ) => {
    const key = "EMPLOYEE_GET_ASSIGNED_LOCATIONS";
    if (forceRefresh) {
      await dispatch(clearAllCacheForBaseKey({ baseKey: key }));
    }
    return cacheApiRequest(key, dispatch, cache, { params });
  };

  const deleteAssignedLocation = async (
    params = { mappingId: 0 }    
  ) => {
    const key = "EMPLOYEE_DELETE_ASSIGNED_LOCATION";
    const result = await cacheApiRequest(key, dispatch, cache, { params });
    await fetchAssignedLocations({ EmployeeId: "All" }, true); // this will refresh the assigned locations after deletion
    return result;
  };

  const AssignLocation = async (data = {}) => {
    const key = "EMPLOYEE_POST_ASSIGN_LOCATION";
    const result = await cacheApiRequest(key, dispatch, cache, { data });
    await fetchAssignedLocations({ EmployeeId: "All" }, true); // this will refresh the assigned locations after assignment
    return result;
  };

  const updateFaceStatus = async (data = {}) => {
  const key = "EMPLOYEE_POST_FACE_STATUS";
   const result=  await cacheApiRequest(key, dispatch, cache, { data });
  //await fetchFaceData();
  return result;

};


  return {
    fetchEmployees,
    fetchFaceData,
    fetchAssignedLocations,
    fetchDetailedLog,
    deleteAssignedLocation,
    AssignLocation,
    fetchAttendanceLogs,
    fetchDetailedAttendanceLogs,
    fetchEmployeeValidationRequirement,
    updateEmployeeValidationRequirement,
    updateFaceStatus  
  };
};
